<div style="width: 100%; height: 100%;">
  <carousel [noWrap]="noWrapSlides" [indicatorsByChunk]="showIndicator" class="no-control" style="position:sticky; top:0;">
    <slide *ngFor="let slide of slides; let index=index">
      <div class="vector"></div>
      <img [src]="slide.image" alt="image slide" class="img">
      <div class="carousel-caption">
        <p><small>{{slide?.title}}</small></p>
        <h4>{{slide?.text}}</h4>
      </div>
    </slide>
  </carousel>
</div>
